import { CaseMode, CaseModeParams } from "@/App/types/CaseMode";
import type { Filter } from "@/Pages/Cases/filtering/filters/CaseFilter";
import type { InFilter } from "@/Pages/Cases/filtering/filters/CaseFilter";

export const modeToFilters = (caseMode: CaseMode): Filter =>
  ({ fieldName: "type", values: CaseModeParams[caseMode].types }) as InFilter;
